/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IsVerifactuEnabled200Response
 */
export interface IsVerifactuEnabled200Response {
    /**
     * 
     * @type {boolean}
     * @memberof IsVerifactuEnabled200Response
     */
    isEnabled: boolean;
}

/**
 * Check if a given object implements the IsVerifactuEnabled200Response interface.
 */
export function instanceOfIsVerifactuEnabled200Response(value: object): value is IsVerifactuEnabled200Response {
    if (!('isEnabled' in value) || value['isEnabled'] === undefined) return false;
    return true;
}

export function IsVerifactuEnabled200ResponseFromJSON(json: any): IsVerifactuEnabled200Response {
    return IsVerifactuEnabled200ResponseFromJSONTyped(json, false);
}

export function IsVerifactuEnabled200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IsVerifactuEnabled200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'isEnabled': json['isEnabled'],
    };
}

export function IsVerifactuEnabled200ResponseToJSON(json: any): IsVerifactuEnabled200Response {
    return IsVerifactuEnabled200ResponseToJSONTyped(json, false);
}

export function IsVerifactuEnabled200ResponseToJSONTyped(value?: IsVerifactuEnabled200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isEnabled': value['isEnabled'],
    };
}

